import { render, staticRenderFns } from "./DispenseDrug.vue?vue&type=template&id=62f4637b&scoped=true"
import script from "./DispenseDrug.vue?vue&type=script&lang=js"
export * from "./DispenseDrug.vue?vue&type=script&lang=js"
import style0 from "./DispenseDrug.vue?vue&type=style&index=0&id=62f4637b&prod&scoped=true&lang=css"
import style1 from "./DispenseDrug.vue?vue&type=style&index=1&id=62f4637b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f4637b",
  null
  
)

export default component.exports